module.exports = __webpack_public_path__ + "img/txt.df017857.png";